
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","d":"M0 0h20v20H0V0z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M5.8 13h.9v2h-.9zm4.2 0h.9v2H10z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M11.7 1.7H3.3v16.7h13.3V6.7l-4.9-5zm-.8 1.2l4.6 4.6h-4.6V2.9zM7.9 15c0 .6-.4 1-1.2 1H4.6v-4h2.1c.8 0 1.2.6 1.2 1v2zm4.2 0c0 .6-.4 1-1.2 1H10c-.8 0-1.2-.4-1.2-1v-2c0-.4.4-1 1.2-1h.9c.8 0 1.2.6 1.2 1v2zm3.3-2h-1.2v2h1.2v1h-1.2c-.8 0-1.2-.4-1.2-1v-2c0-.4.4-1 1.2-1h1.2v1z"}})])
          )
        }
      }
    